import { FormattedMessage } from 'react-intl';
import styled, { FlattenSimpleInterpolation } from 'styled-components';
import tw from 'tailwind.macro';
import { Icon40 } from '../../../../components/Icon';
import { P2 } from '../../../../components/Typographies/Paragraph';
import { H5 } from '../../../../components/Typographies/Title';
import ImageProfile from '../../../../images/icons/smile.svg';
import ImageChat from '../../../../images/illustrated/buble-discussion-104.svg';
import { COMMENTS } from './constants';
import { homePageReviewMessages } from './messages';

const Wrapper = styled.div`
  ${tw`p-medium2 rounded-30 shadow-medium bg-white`}
`;
const Header = styled.div`
  ${tw`flex items-center mb-big`}
  gap:var(--size-medium)
`;
const Image = styled.img`
  ${Icon40}
`;

const Author = styled(P2)`
  ${tw`mt-medium`}
`;

const Card = ({ data }) => (
  <Wrapper>
    <Header>
      <Image alt="Smile icon" src={ImageProfile} />
      <strong>
        <H5 as="span">{data.trip}</H5>
      </strong>
    </Header>

    <P2>
      <FormattedMessage {...homePageReviewMessages[data.comment]} />
    </P2>

    <Author>
      <strong>@{data.name}</strong>
    </Author>
  </Wrapper>
);

const Container = styled.div<CardProps>`
  ${tw` relative flex flex-col md:flex-row`}
  gap:var(--size-medium2);

  &:after {
    ${tw`hidden lg:block absolute`}
    right:-163px;
    top: -72px;
    content: url(${ImageChat});
    ${({ imageCustomStyle }) => imageCustomStyle}
  }
`;

type CardProps = {
  imageCustomStyle?: FlattenSimpleInterpolation;
};

const Cards = (props: CardProps) => (
  <Container {...props}>
    {COMMENTS.map((comment, index) => (
      <Card key={index} data={comment} />
    ))}
  </Container>
);

export default Cards;
